<ion-content class="bg-color ion-content user-details">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <ng-container *ngIf="itemList.embedurl; else noRoute">
            <a href="javascript:void(0)" routerLink="{{ itemList.url }}">
              {{ itemList.label }}
            </a>
          </ng-container>
          <ng-template #noRoute>
            <a style="text-decoration: none; cursor: none;" href="javascript:void(0)">
              {{ itemList.label }}
            </a>
          </ng-template>

        </li>
      </ul>
    </div>
    <div class="content-grid">
      <div class="m-content">
        <mat-card>
          <mat-card-title class="mc-title">
            <h4 class="mat-title-header">Organization</h4>
          </mat-card-title>
          <mat-card-content class="mc-content">
            <div class="form-container">
              <div class="list-info">
                <span>First Name</span>
                <span>{{orgObj?.first_name}}</span>
              </div>
              <div class="list-info">
                <span>Last Name</span>
                <span>{{orgObj?.last_name}}</span>
              </div>
              <div class="list-info">
                <span>Work Email Address</span>
                <span>{{orgObj?.email}}</span>
              </div>
              <div class="list-info">
                <span>Phone Number</span>
                <span>{{orgObj?.phone_no}}</span>
              </div>
              <div class="list-info">
                <span>Job Title</span>
                <span>{{orgObj?.job_title}}</span>
              </div>
              <div class="list-info">
                <span>Employee</span>
                <span>{{orgObj?.employee}}</span>
              </div>
              <div class="list-info">
                <span>Company</span>
                <span>{{orgObj?.company}}</span>
              </div>
              <div class="list-info">
                <span>Country</span>
                <span>{{orgObj?.country}}</span>
              </div>
              <div class="list-info">
                <span>Client ID</span>
                <span>{{orgObj?.biz_client_id}}</span>
              </div>
              <div class="list-info">
                <span>Client Secret</span>
                <span>{{orgObj?.biz_client_secret}}</span>
              </div>
              <div class="list-info">
                <span>Free Trail Mode</span>
                <span>{{orgObj?.free_trial_mode == 1? "Yes": "No"}}</span>
              </div>
              <div class="list-info">
                <span>Subscription Start Date</span>
                <span>{{orgObj?.subscription_start_date | date: 'medium'}}</span>
              </div>
              <div class="list-info">
                <span>Subscription End Date</span>
                <span>{{orgObj?.subscription_end_date | date: 'medium'}}</span>
              </div>
              <div class="list-info">
                <span>Subscription</span>
                <span>{{orgObj?.subscription_number}}</span>
              </div>
              <div class="list-info">
                <span>Company Address</span>
                <span>{{orgObj?.company_address}}</span>
              </div>
              <div class="list-info">
                <span>Company Logo</span>
                <span><div class="logo">
                  <img [src]="imagePath">
                </div></span>
              </div>

            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="margin-top-10">
          <mat-card-title class="mc-title">
            <h4 class="mat-title-header">Additional Information</h4>
          </mat-card-title>
          <mat-card-content class="mc-content">
            <div class="form-container">
              <div class="list-info">
                <span>Created By</span>
                <span>{{orgObj?.first_name}} {{orgObj?.last_name}}</span>
              </div>
              <div class="list-info">
                <span>Updated By</span>
                <span>{{orgObj?.updated_by}}</span>
              </div>
              <div class="list-info">
                <span>Created Date</span>
                <span>{{orgObj?.created_date | date: 'medium'}}</span>
              </div>
              <div class="list-info">
                <span>Updated Date</span>
                <span>{{orgObj?.updated_date | date: 'medium'}}</span>
              </div>
              <div class="list-info">
                <span>Created IP Address</span>
                <span>{{orgObj?.create_ip_address}}</span>
              </div>
              <div class="list-info">
                <span>Updated IP Address</span>
                <span>{{orgObj?.update_ip_address}}</span>
              </div>
              <div class="btn-signup-grid">
                <button mat-raised-button type="submit" routerLink="/baseapp/organization"class="btn btn-signup">Go Back</button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <app-about-page *ngIf="hide1200"></app-about-page>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>
